import script from "./menuListPage.vue?vue&type=script&setup=true&lang=js"
export * from "./menuListPage.vue?vue&type=script&setup=true&lang=js"

import "./menuListPage.vue?vue&type=style&index=0&id=06f7a034&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06f7a034"]])

export default __exports__